import React, { useState, useEffect } from 'react';
import { lightTheme } from '../../SharedComponents/SharedComponentStyles';
import { Box, ThemeProvider } from '@material-ui/core';
import axios from 'axios';
import * as XLSX from "xlsx";
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { Grid, Button, TextField } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { forwardRef } from "react";
import DateFnsUtils from "@date-io/date-fns";
import BulkSlipDownloadTemplate from '../BulkSlipCreation/Template/BulkSlipDownloadTemplate.xlsx';
import { Link } from "react-router-dom";
import Dialog from '@material-ui/core/Dialog';
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import MaterialTable from "material-table";

import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
    AddBox,
    Check,
    DeleteOutline,
    Edit,
    SaveAlt,
    FilterList,
    FirstPage,
    LastPage,
    ChevronRight,
    ChevronLeft,
    Clear,
    Search,
    ArrowDownward,
    Remove,
    ViewColumn,
} from "@material-ui/icons";
import { useSelector, useDispatch } from "react-redux";

const api_SapUpload = axios.create({
    baseURL: 'PhyInvSAPUpload'
})
const api_SlipUpload = axios.create({
    baseURL: 'PhyInvSlipUpload'
})
export const tableIconsInputScreen = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => (
        <Check {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
    )),
    Clear: forwardRef((props, ref) => (
        <Clear {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
    )),
    Delete: forwardRef((props, ref) => (
        <DeleteOutline {...props} ref={ref} style={{ color: "var(--red)" }} />
    )),
    DetailPanel: forwardRef((props, ref) => (
        <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => (
        <Edit {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
    )),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
        <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => (
        <Search {...props} ref={ref} style={{ fontSize: "2.5rem" }} />
    )),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};


export default function BulkSlipCreation(props) {

    var columns = [
        { title: "slipId", field: "slipId", hidden: true },
        { title: "Slip Number", field: "slipnumber" },
        { title: "Plant Id", field: "plantname" },
        { title: "Location", field: "locationName" },
        { title: "Material Number", field: "materialName" },
        { title: "Material Name", field: "materialDescription" },
        { title: "ABC Classification", field: "abcclassiification" },
        { title: "Measuring Unit", field: "unitOfMeasurement" },
        { title: "Entered Quantity", field: "countedPhyQuantity", type: 'numeric', align: 'left' },
        { title: "Comment", field: "remarks" },
        { title: "Entered By", field: "slipCreatedBy" },
        { title: "Entered On", field: "createdDate" },
        { title: "Modified By", field: "slipModifieddBy" },
        { title: "Modified On", field: "modifiedDate" },

    ];

    const [selectedFileDept, setSelectedFileDept] = useState(null);//firstfileupload
    const [drawingpdfKey, setDrawingpdf] = useState(Date.now);
    const handlefirstfileUpload = (e) => {
        setSelectedFileDept(e.target.files[0]);
       // console.log(e.target.files[0]);
    };
    const handleErrorClose = (e) => {
        setIserror(false);
    }
    const [fileValue, setfileValue] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [UserId, seUserId] = useState(props.loginuser.response.employeeId);
    //for  viewing uploaded bulk slip data 
    const [viewSlipData, setviewSlipData] = useState([]);

    //for error handling 
    const [iserror, setIserror] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [severity, setSeverity] = useState('success');
    const [isUploadSucess, setIsUploadSucess] = useState(false);
    const [openLoader, setopenLoader] = useState(false);
    const [openForm, setopenForm] = useState(false);
    const [editRowData, seteditRowData] = useState([]);
    const [mode, setMode] = useState("");

    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
      (state) => state.storeUserDetailsReducer.userData
    );
    const bearerToken = useSelector(
      (state) => state.saveBearerTokenReducer.bearerToken
    );
    const uId = useSelector((state) => state.saveUIDReducer.uid);



    let isValidate = true;
    let errorList = [];

    function clickEdit(rowData) {
       // console.log(rowData);
        setMode("edit");
        setopenForm(true);
        seteditRowData(rowData);

        //window.location.href = "/UpdateSlipInventory";
    }
    function GetEditButton(rowData) {
        return (
            <Tooltip title="Modify Slip" placement="bottom">
                <span>
                    <Button href="javascript:void(0)">
                        <span>
                            <EditOutlinedIcon fontSize="small" className="attachFileIcon" />
                        </span>
                    </Button>
                </span>
            </Tooltip>
        );
    }

    function filePathset_Value(e) {
        let errorList = [];
        e.stopPropagation();
        e.preventDefault();
        var valuetemplatefile = e.target.files[0];
        var elementSAP = document.getElementById("SAPUploadFile");
        var element1SAP = elementSAP.parentElement.parentElement;
        setSelectedFile(e.target.files[0]);
        element1SAP.classList.remove("udi-error");
        if (valuetemplatefile !== undefined) {
            var extension = valuetemplatefile.name.split('.')[valuetemplatefile.name.split('.').length - 1];
            if (extension.toString().toUpperCase() === 'XLSX') {
                setfileValue(valuetemplatefile);
                setIsUploadSucess(false);
            }
            else {
                setfileValue(null);
                document.getElementById('SAPUploadFile').value = null;
                errorList.push("Upload Excel file only.");
                showMessage(errorList, true, 'error');
            }
        }
    }
    function ExportDataToExcel(errorData) {
        const dataToDownload = errorData.map((row) => {
            return {
                RowNumber: row.rowIndex,
                plantName: row.plantName,
                location: row.location,
                materialNumber: row.materialNumber,
                CountedPhysicalQuantity: row.countedPhysicalQuantity,
                remarks: row.remarks,
                ErrorMessage: row.errorMsg
            };
        });
        let headers = ["RowNumber", "PlantName", "Location", "MaterialNumber", "CountedPhysicalQuantity", "Remarks", "Error Message"];

        //const workSheet = XLSX.utils.json_to_sheet(newData);
        let ws = XLSX.utils.book_new();
        let wb = XLSX.utils.book_new();
        XLSX.utils.sheet_add_aoa(ws, [headers]);
        XLSX.utils.sheet_add_json(ws, dataToDownload, {
            origin: "A2",
            skipHeader: true,
            cellStyles: true,
        });
        //ws["!cols"] = cellAdjustToContentsCustomer(dataToDownload);
        XLSX.utils.book_append_sheet(wb, ws, "ErrorData");
        XLSX.write(wb, { bookType: "xlsx", type: "binary" });
        //Download
        XLSX.writeFile(wb, "SlipBulkUploadErrors.xlsx");
    }

    async function submitDatacall(e) {
        checkValidations();
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("UserId", UserId);
        bulkUploadSAPList(formData);
    }
    function showMessage(errorList, flag, severity) {
        setErrorMessages(errorList);
        setIserror(flag);
        setSeverity(severity);
    }
    
    {/*    async function GetViewBulkSlipDetails(formData) {
        let isValidate = true;
        let errorList = [];        
        if (isValidate) {

            setopenLoader(true);           
            await api.get("/getBulkSlipDetails/", formData)
                .then(res => {
                    setviewSlipData(res.data);
                    console.log("viewSlip", res.data);
                    setopenLoader(false);
                })
                .catch(error => {
                    console.log("Error in hitting api : BulkSlipGenDetails")
                    setopenLoader(false);
                })
        }
    }*/}

    async function checkValidations() {
        if (fileValue == "" || fileValue === null || fileValue === undefined) {
            isValidate = false;
            errorList.push("Please select file!");
            showMessage(errorList, true, 'error');
        }
        return isValidate;
    }

    async function CreateBulkSlip() {
        checkValidations();
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("UserId", UserId);
        if (isUploadSucess) {
            SubmitSlipDetails(formData);

        }
        else {
            errorList.push("Please upload the selected file!!!.");
            showMessage(errorList, true, 'error');
        }
    }

    async function SubmitSlipDetails(formData) {
        let response = [];
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        if (isValidate) {
            setopenLoader(true);
            await api_SlipUpload.post("/CreateBulkSlip/", formData,{headers: headers})
                .then((result) => {
                    response = result.data;
                    setopenLoader(false);
                    if (response.result.slipTempResult != null) {
                        if (response.result.slipTempResult.length > 0) {
                            setviewSlipData(response.result.slipTempResult);
                           // console.log("VIEW RESPONSE!!", response.result.slipTempResult);
                        }
                    }
                    errorList.push("Slips were created successfully!!!");
                    showMessage(errorList, true, 'success');                   

                })
                .catch((error) => {
                    console.log("Error : ", error);
                    setopenLoader(false);
                    errorList.push("Something went wrong!");
                    showMessage(errorList, true, 'error');
                });
        }

        else {
            setopenLoader(false);
        }
        //reset();
    }

    async function bulkUploadSAPList(formData) {
        let response = [];
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };

        if (isValidate) {
            setopenLoader(true);
            await api_SlipUpload.post("/SaveUploadedData/", formData,{headers: headers})
                .then((result) => {
                    response = result.data;
                    if (response.result.objResult != null) {
                        if (response.result.objResult.length > 0) {
                            setopenLoader(false);
                            // console.log("UPLOAD RESPONSE!!", response.result.objResult);
                            ExportDataToExcel(response.result.objResult);
                            errorList.push("File uploaded failed. Please check dowloaded error data file!!!!");
                            showMessage(errorList, true, 'error');
                            setIsUploadSucess(false);
                        }
                        else {
                            setopenLoader(false);
                            errorList.push(response.result.responseMsg);
                            showMessage(errorList, true, 'error');
                            setIsUploadSucess(false);
                        }
                    }

                    else {
                        setopenLoader(false);
                        setIsUploadSucess(true);
                        errorList.push("File uploaded successfully!!!");
                        showMessage(errorList, true, 'success');
                    }
                })
                .catch((error) => {
                    console.log("Error : ", error);
                    setopenLoader(false);
                    setIsUploadSucess(false);
                    errorList.push("Something went wrong!");
                    showMessage(errorList, true, 'error');

                });
        }

        else {
            setopenLoader(false);

        }
        //reset();
    }
    return (
        <ThemeProvider theme={lightTheme}>
            <div className="master-layout-data">
                <Box paddingTop={{ xs: '5rem', sm: '2rem' }} className="">
                    <h3 className="clr-dark-blue d-flex jc-center mt-2 mb-1">Bulk Slip Creation</h3>
                </Box>

                <Grid container spacing={2} className="d-flex mt-1 fd-row mb-1 px-1 width-100 bdr-radius ">
                    <Grid container spacing={2} xs={12} style={{ margin: "10px 0px 10px 0px" }}>
                        <Grid item xs={12} md={3} className="d-flex width-100">
                            <a
                                href={BulkSlipDownloadTemplate}
                                download="BulkSlipDownloadTemplate.xlsx"
                                target="_blank"
                            >
                                <Button
                                    className="ns-btn-primary mt-1 mr-1"
                                    type="submit"
                                >
                                    Download Template
                                </Button>
                            </a>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} xs={12}>
                        <Grid item xs={12} md={3}>
                            <TextField
                                id="SAPUploadFile"
                                variant="filled"
                                className="bulk-upload"
                                type="file"
                                name="bulkUpload"
                                onChange={(e) => filePathset_Value(e)}
                            />
                        </Grid>
                        <Grid item xs={12} md={3} className="d-flex width-100">
                            <Button
                                className="ns-btn-primary mt-1 mr-1"
                                type="submit"
                                onClick={submitDatacall}
                            >
                                Upload
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} xs={12}>
                        <Grid item xs={12} md={3} className="d-flex width-100">
                            <Button
                                className="ns-btn-primary mt-1 mr-1"
                                type="submit"
                                onClick={CreateBulkSlip} disabled={isUploadSucess == true ? false : true}
                            >
                                Create Slip
                            </Button>
                        </Grid>

                        <Grid item xs={12} md={3} className="d-flex width-100">
                            <Button variant="contained" component={Link} to="/ModifyInventory"
                                className="ns-btn-primary mt-1 mr-1">
                                View Slip
                            </Button>
                        </Grid>

                    </Grid>

                    <Grid item xs={12} sm={12} className="userManagement mt-1 mb-1">
                        <div>
                            {iserror &&
                                <Alert severity={severity} onClose={handleErrorClose}>
                                    {errorMessages.map((msg, i) => {
                                        return <div key={i}>{msg}</div>
                                    })}
                                </Alert>
                            }
                        </div>
                    </Grid>


                    <Grid container >
                        <Grid item xs={12}  >
                            <MaterialTable
                                title=""
                                columns={columns}
                                data={viewSlipData}
                                //align={CenterFocusStrong}
                                icons={tableIconsInputScreen}

                                //actions={[

                                //    rowData => ({
                                //        icon: GetEditButton,
                                //        tisFreeAction: true,
                                //        onClick: (event, rowData) => clickEdit(rowData),
                                //    }),
                                //]}
                                options={{

                                    exportButton: {
                                        csv: true,
                                        pdf: false
                                    },
                                    exportAllData: true,
                                    exportFileName: "ViewBulkSlip",
                                    pageSize: 50,
                                    pageSizeOptions: [50, 75, 100],
                                    search: false,
                                }}

                            />

                        </Grid>
                    </Grid>


                </Grid>
                <Dialog
                    open={openLoader}
                    //onClose={handleClose}
                    aria-labelledby="draggable-dialog-title"
                    id="templateUploadSuccess"
                    PaperProps={{
                        style: {
                            backgroundColor: "transparent",
                            boxShadow: "none",
                            borderColor: "transparent"
                        },
                    }}>
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>
            </div>
        </ThemeProvider>
    );
}